import { useState } from "react";
import { setLanguage } from "../lang";

const LanguageToggle = ({ lang, setLang }) => {
  const [flash, setFlash] = useState(false);


  const handleToggle = () => {
    const newLang = lang === "en" ? "sl" : "en";
    setLang(newLang);
    setLanguage(newLang); // update text on page
  };



  return (
    <div className="language-toggle">
      <button onClick={handleToggle}>
        {lang === "en" ? (
          <>
            EN<br />
            <img src="https://flagcdn.com/gb.svg" alt="EN" width="30" height="30" />
          </>
        ) : (
          <>
            SL<br />
            <img src="https://flagcdn.com/si.svg" alt="SL" width="30" height="30" />
          </>
        )}
      </button>
    </div>
  );
};

export default LanguageToggle;
